<svg
  width="395"
  height="820"
  viewBox="0 0 395 820"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g filter="url(#filter0_d_650_4976)">
    <path
      d="M71.9381 816.726C34.8749 816.726 4.71973 785.644 4.71973 747.438V69.2846C4.71973 31.0796 34.8741 0 71.9381 0H324.781C361.846 0 392 31.0803 392 69.2846V747.438C392 785.644 361.847 816.726 324.781 816.726H71.9381Z"
      fill="url(#paint0_linear_650_4976)"
    />
    <path
      d="M10.4944 749.606V71.4558C10.4944 34.323 39.8007 4.1122 75.8252 4.1122H328.668C337.045 4.1122 345.048 5.7607 352.413 8.73305C343.876 4.50526 334.312 2.13354 324.222 2.13354H71.379C35.3537 2.13354 6.0459 32.3467 6.0459 69.4795V747.633C6.0459 776.136 23.3199 800.54 47.6362 810.356C25.6826 799.486 10.4937 776.344 10.4937 749.607L10.4944 749.606Z"
      fill="url(#paint1_linear_650_4976)"
    />
    <path
      d="M4.7194 106.042C2.52221 106.042 0.742188 107.86 0.742188 110.1V165.709C0.742188 167.954 2.52221 169.77 4.7194 169.77V106.042Z"
      fill="url(#paint2_linear_650_4976)"
    />
    <rect width="352" height="682" transform="translate(22 69)" fill="black" />
    <path
      d="M324.779 800.665H71.9363C43.4635 800.665 20.2988 776.787 20.2988 747.437V69.285C20.2988 39.9373 43.4635 16.061 71.9363 16.061H324.78C353.253 16.061 376.418 39.9373 376.418 69.285V747.437C376.418 776.787 353.252 800.665 324.779 800.665ZM71.9363 18.3486C44.6876 18.3486 22.5189 41.199 22.5189 69.285V747.437C22.5189 775.526 44.6876 798.377 71.9363 798.377H324.78C352.029 798.377 374.198 775.526 374.198 747.437V69.285C374.198 41.199 352.03 18.3486 324.78 18.3486H71.9363Z"
      fill="#231F20"
    />
    <path
      d="M338.888 32.5647V38.5425C338.89 39.6808 337.828 40.6084 336.525 40.6084H319.14C317.839 40.6084 316.776 39.6808 316.776 38.5425V37.9466C316.294 37.835 315.691 37.5566 315.691 37.0897V34.0191C315.691 33.5506 316.294 33.2738 316.776 33.1622V32.5647C316.776 31.4257 317.839 30.498 319.14 30.498H336.525C337.827 30.498 338.888 31.4257 338.888 32.5647ZM317.653 38.5425C317.653 39.2578 318.319 39.8435 319.14 39.8435H336.525C337.346 39.8435 338.013 39.2578 338.013 38.5425V32.5647C338.013 31.8502 337.346 31.2637 336.525 31.2637H319.14C318.319 31.2637 317.653 31.8509 317.653 32.5647V33.8673H317.214C317.037 33.8673 316.68 33.9853 316.567 34.0765V37.0315C316.68 37.1211 317.037 37.2399 317.214 37.2399H317.653V38.5425Z"
      fill="#6D6E71"
    />
    <path d="M321.52 32.0852H319.003V38.8656H321.52V32.0852Z" fill="#6D6E71" />
    <path d="M325.296 32.0852H322.78V38.8656H325.296V32.0852Z" fill="#6D6E71" />
    <path
      d="M329.073 32.0852H326.555V38.8656H329.073V32.0852Z"
      fill="#6D6E71"
    />
    <path
      d="M332.851 32.0852H330.333V38.8656H332.851V32.0852Z"
      fill="#6D6E71"
    />
    <path
      d="M336.625 32.0852H334.108V38.8656H336.625V32.0852Z"
      fill="#6D6E71"
    />
    <path
      d="M67.1551 32.8318H62.9277V38.2741H67.1551V32.8318Z"
      fill="#808285"
    />
    <path
      d="M73.3037 32.8318H69.0771V38.2741H73.3037V32.8318Z"
      fill="#808285"
    />
    <path
      d="M79.4516 32.8318H75.2266V38.2741H79.4516V32.8318Z"
      fill="#808285"
    />
    <path d="M85.5989 32.8318H81.373V38.2741H85.5989V32.8318Z" fill="#808285" />
    <path
      d="M91.7449 32.8318H87.5176V38.2741H91.7449V32.8318Z"
      fill="#808285"
    />
    <path
      d="M98.0379 32.8318H93.8105V38.2741H98.0379V32.8318Z"
      fill="#808285"
    />
    <path
      d="M125.332 18.3474V27.4547C125.332 35.143 130.232 41.3754 136.277 41.3754H256.23C262.275 41.3754 267.175 35.143 267.175 27.4547V18.3474H125.333H125.332Z"
      fill="#231F20"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_650_4976"
      x="0.742188"
      y="0"
      width="394.258"
      height="819.726"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dx="3" dy="3" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_650_4976"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_650_4976"
        result="shape"
      />
    </filter>
    <linearGradient
      id="paint0_linear_650_4976"
      x1="473.553"
      y1="692.029"
      x2="-93.5173"
      y2="141.894"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1C1C1C" />
      <stop offset="1" stop-color="#4D4D4D" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_650_4976"
      x1="6.0459"
      y1="406.244"
      x2="352.414"
      y2="406.244"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#C7C7C7" />
      <stop offset="0.109" stop-color="white" />
      <stop offset="0.333" stop-color="#BDBDBD" />
      <stop offset="1" stop-color="#919191" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_650_4976"
      x1="19.7604"
      y1="154.266"
      x2="-12.9432"
      y2="122.538"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#636363" />
      <stop offset="0.235" stop-color="#6B6B6B" />
      <stop offset="0.617" stop-color="#848484" />
      <stop offset="1" stop-color="#A3A3A3" />
    </linearGradient>
  </defs>
</svg>
